import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function NotFound() {
  const { t, i18n } = useTranslation();
  
  const getLocalizedPath = (path: string) => {
    return i18n.language === 'en' ? path : `/${i18n.language}${path}`;
  };

  return (
    <>
      <Helmet>
        <title>404 - Page Not Found | BridgeOnce</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <main className="pt-24 bg-background">
        <div className="max-w-7xl mx-auto px-6 py-24 text-center">
          <h1 className="text-4xl lg:text-5xl font-bold text-primary mb-6">
            {t('notFound.title', '404 - Page Not Found')}
          </h1>
          <p className="text-xl text-text/80 mb-8">
            {t('notFound.description', "The page you're looking for doesn't exist.")}
          </p>
          <Link 
            to={getLocalizedPath('/')}
            className="inline-block bg-primary text-white px-6 py-3 rounded-lg hover:bg-primary/90 transition-colors"
          >
            {t('notFound.backHome', 'Back to Home')}
          </Link>
        </div>
      </main>
    </>
  );
} 